import React, { useContext, useEffect, useState } from "react";
import { Card, Label, ModalBody, Badge, DropdownMenu, DropdownToggle, UncontrolledDropdown, Modal, DropdownItem, Form, ModalHeader, ModalFooter, } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    Col,
    Row,
    OverlineTitle,
    Sidebar,
    UserAvatar,
} from "../../../components/Component";
import { useHistory } from "react-router";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { urlTenantID, currentTime, findUpper, formatDates, formateDateTenant, monthNames, todaysDate } from "../../../utils/Utils";
import { UserContext } from "../user-manage/UserContext";
import { notes } from "../user-manage/UserData";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import Api from "../../../Api";
import TenantTab from "./TenantTab";
import TenantHeading from "./TenantHeading";
import { useForm } from "react-hook-form";

import { DateRangePicker } from 'react-date-range';
import '../../../../node_modules/react-date-range/dist/styles.css';
import '../../../../node_modules/react-date-range/dist/theme/default.css';
import Swal from "sweetalert2";

const License = ({ match }) => {
    const [licenseListState, setLicenseList] = useState([]);
    const { contextData } = useContext(UserContext);
    const [data] = contextData;
    const location = useLocation()
    const [sideBar, setSidebar] = useState(false);
    const [user, setUser] = useState();
    const [noteData, setNoteData] = useState(notes);
    const [addNoteModal, setAddNoteModal] = useState(false);
    const [addNoteText, setAddNoteText] = useState("");
    const history = useHistory();
    const [modal, setModal] = useState({
        add: false,
        edit: false,
    });
    const [showPicker, setShowPicker] = useState(false);

    const [editData, setEditData] = useState({});

    const { errors, register, handleSubmit } = useForm();

    const [selectedRange, setSelectedRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        },
    ]);

    const [gettenantId, setGetTenantId] = useState(urlTenantID());


    const callGetTenantLicenseByTenantID = async () => {
        const tenantLicenseListData = await Api.GetTenantLicenseByTenantID({ TenantId: gettenantId }); //match.params.id
        setLicenseList(tenantLicenseListData);
        //setTenantDetail({...tenantDetailState,[tenantId]: "1"});
    }
    useEffect(async () => {
        await callGetTenantLicenseByTenantID();
    }, []);


    // grabs the id of the url and loads the corresponding data
    useEffect(() => {
        const id = match.params.id;
        if (id !== undefined || null || "") {
            let spUser = data.find((item) => item.id === Number(id));
            setUser(spUser);
        } else {
            setUser(data[0]);
        }
    }, [match.params.id, data]);

    // function to toggle sidebar
    const toggle = () => {
        setSidebar(!sideBar);
    };

    // delete a note
    const deleteNote = (id) => {
        let defaultNote = noteData;
        defaultNote = defaultNote.filter((item) => item.id !== id);
        setNoteData(defaultNote);
    };

    const submitNote = () => {
        let submitData = {
            id: Math.random(),
            text: addNoteText,
            date: `${monthNames[todaysDate.getMonth()]} ${todaysDate.getDate()}, ${todaysDate.getFullYear()}`,
            time: `${currentTime()}`,
            company: "Softnio",
        };
        setNoteData([...noteData, submitData]);
        setAddNoteModal(false);
        setAddNoteText("");
    };

    const onFormCancel = () => {
        setModal({ ...modal, add: false, edit: false });
    }

    const handleaddLicense = async (eve) => {
        let data = {
            "tenantId": gettenantId,
            "licCode": "L-000001",
            "serviceStartDate": formatDates(selectedRange[0]?.startDate),
            "serviceEndDate": formatDates(selectedRange[0]?.endDate),
            "createdBy": "TestDv"
        }
        try {
            let response = await Api?.InsertTenantSingleLicense(data);
            Swal?.fire({
                icon: response?.data?.message?.includes("success") ? "success" : "error",
                title: response?.data?.message?.includes("success") ? "License Added Successfully" : "Something Went Wrong"
            });
            setShowPicker(false);
            setModal({ ...modal, add: false, edit: false });
            let resetDateRange = [
                {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection',
                },
            ];
            setSelectedRange(resetDateRange);
            callGetTenantLicenseByTenantID();

        } catch (error) {
            Swal?.fire({
                icon: "error",
                title: "Something Went Wrong"
            });
        }
    }

    const handleSubmitEditLicense = async () => {
        let createdBy = localStorage?.getItem("formDataUsername");
        let data = {
            "tenantId": gettenantId,
            "tlid": editData?.tlid,
            "licCode": editData?.licCode,
            "serviceStartDate": formateDateTenant(selectedRange[0]?.startDate),
            "serviceEndDate": formateDateTenant(selectedRange[0]?.endDate),
            "createdBy": createdBy ? localStorage?.getItem("formDataUsername") : "",
        }
        try {
            let response = await Api?.UpdateSingleTenantLicense(data);
            Swal?.fire({
                icon: response?.data?.message?.includes("success") ? "success" : "error",
                title: response?.data?.message?.includes("success") ? "License Updated Successfully" : "Something Went Wrong"
            });
            setShowPicker(false);
            setModal({ ...modal, add: false, edit: false });
            let resetDateRange = [
                {
                    startDate: new Date(),
                    endDate: new Date(),
                    key: 'selection',
                },
            ];
            setSelectedRange(resetDateRange);
            callGetTenantLicenseByTenantID();
        } catch (error) {
            Swal?.fire({
                icon: "error",
                title: "Something Went Wrong"
            });
        }



    }

    const handleDateRange = (ranges) => {
        // This function gets called whenever a date range is selected
        setSelectedRange([ranges.selection]);
    };

    const handleInputClick = () => {
        setShowPicker(true);
    };

    const formattedDate = () => {
        if (selectedRange[0]) {
            const { startDate, endDate } = selectedRange[0];
            return `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
        }
        return '';
    };

    const handleCloseButtonClick = () => {
        setShowPicker(false);
    };

    const handleEditLicense = (eve, dates) => {
        setEditData(dates);
        setModal({ ...modal, edit: true, add: false });
        let dateInside = [{
            startDate: new Date(dates?.serviceStartDate),
            endDate: new Date(dates?.serviceEndDate),
            key: 'selection',
        }];
        setSelectedRange(dateInside);
        setShowPicker(false);
    }

    const handleDelLicense = async (data) => {
        try {
            let response = await Api?.deleteSingleTenantLicense(data);
            Swal?.fire({
                icon: response?.data?.statusCode === 200 ? "success" : "error",
                title: response?.data?.statusCode === 200 ? "License Deleted Successfully" : "Something Went Wrong",
            });
            callGetTenantLicenseByTenantID()
        } catch (error) {
            Swal?.fire({
                icon: "error",
                title: "Something Went Wrong"
            })
        }
    }

    const handleDeleteLicense = async (eve, item) => {
        Swal?.fire({
            icon: "question",
            title: `Do you Want to delete ${item?.tlid} ??`,
            showDenyButton: true,
            confirmButtonColor: "#dc3741",
            confirmButtonClass: 'license_btn',
            confirmButtonText: "Delete",
            denyButtonText: `Cancel`,
            denyButtonColor: "#854fff"
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    "tlid": item?.tlid,
                    "updateBy": localStorage?.getItem("LoginUserName") || "",
                    "tenantId": item?.tenantId
                }
                handleDelLicense(data)
            }
            //  else if (result.isDenied) {

            // }
        });
    }


    return (
        <React.Fragment>
            <Head title="User Details - Regular"></Head>
            {user && (
                <Content className="position-relative">
                    <TenantHeading heading={"Add Tenant Detail"} />
                    <TenantTab match={match} />

                    <Block>
                        <Card className="card-bordered">
                            <div className="card-aside-wrap" id="user-detail-block">
                                <div className="card-content">

                                    <div className="card-inner">
                                        <Block>
                                            <div className="d-flex justify-content-between flex-wrap mb-3">
                                                <h4 className="">License</h4>
                                                <div className="">
                                                    <Button color="primary" onClick={() => { setModal({ add: true }); setShowPicker(false); }}>
                                                        <Icon name="plus" />
                                                        <span>Add</span>
                                                    </Button>
                                                </div>
                                            </div>
                                            <table className="table">
                                                <thead className="table-light">
                                                    <tr className="responsive_license">
                                                        <th scope="col" className="responsive_pad_st_0">Code</th>
                                                        <th scope="col">Start Date</th>
                                                        <th scope="col">End Date</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {licenseListState?.length > 0
                                                        ? licenseListState?.map((item) => (
                                                            <tr className="responsive_license">
                                                                <th scope="row">{item.licCode}</th>
                                                                <td>{item.serviceStartDate?.split("T")[0]}</td>
                                                                <td>{item.serviceEndDate?.split("T")[0]}</td>
                                                                <td className="d-flex">
                                                                    <Icon name="edit" className={"fs-3 me-3 text-primary cursor_pointer"} onClick={eve => handleEditLicense(eve, item)}></Icon>
                                                                    <Icon name="delete" className={"fs-3 text-danger cursor_pointer"} onClick={eve => handleDeleteLicense(eve, item)}></Icon>
                                                                </td>
                                                            </tr>
                                                        ))
                                                        : null}
                                                </tbody>
                                            </table>
                                        </Block>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Block>
                </Content>
            )}

            <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
                <ModalHeader
                    close={
                        <button className="close" href="#close"
                            onClick={(ev) => {
                                ev.preventDefault();
                                onFormCancel();
                            }}>
                            <Icon name="cross" />
                        </button>
                    }
                >
                    Add License
                </ModalHeader>
                <ModalBody>
                    <form onSubmit={handleSubmit(eve => handleaddLicense(eve))} autoComplete="off">
                        <Row className="mb-3">
                            <Col md="12">
                                <div className="form-group">
                                    <label className="form-label">Service Date</label>
                                    <input
                                        type="text"
                                        value={formattedDate()}
                                        onClick={handleInputClick}
                                        readOnly
                                        className="form-control bg-blue-dim"
                                    />
                                    {showPicker && (
                                        <div className="position-relative dateSection">
                                            <DateRangePicker
                                                ranges={selectedRange}
                                                onChange={handleDateRange}
                                            />
                                            <Icon name={"cross"} onClick={handleCloseButtonClick} style={{ cursor: "pointer" }} className={"datePickerCloseBtn position-absolute fs-2 "}> </Icon>
                                        </div>
                                    )}
                                </div>
                            </Col>

                        </Row>

                        <div className="justify-end">
                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                <li>
                                    <Button color="primary" size="md" type="submit">
                                        Save
                                    </Button>
                                </li>
                                <li>
                                    <a
                                        href="#cancel"
                                        onClick={(ev) => {
                                            ev.preventDefault();
                                            onFormCancel();
                                        }}
                                        className="link link-light"
                                    >
                                        Cancel
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </form>
                </ModalBody>
            </Modal>

            <Modal isOpen={modal?.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
                <ModalHeader
                    close={
                        <button className="close" href="#close"
                            onClick={(ev) => {
                                ev.preventDefault();
                                onFormCancel();
                            }}>
                            <Icon name="cross" />
                        </button>
                    }
                >
                    Edit License
                </ModalHeader>
                <ModalBody>
                    <form onSubmit={handleSubmit(eve => handleSubmitEditLicense(eve))} autoComplete="off">
                        <Row className="mb-3">
                            <Col md="12">
                                <div className="form-group">
                                    <label className="form-label">Service Date</label>
                                    <input
                                        type="text"
                                        value={formattedDate()}
                                        onClick={handleInputClick}
                                        readOnly
                                        className="form-control bg-blue-dim"
                                    />
                                    {showPicker && (
                                        <div className="position-relative dateSection">
                                            <DateRangePicker
                                                ranges={selectedRange}
                                                onChange={handleDateRange}
                                            />
                                            <Icon name={"cross"} onClick={handleCloseButtonClick} style={{ cursor: "pointer" }} className={"datePickerCloseBtn position-absolute fs-2 "}> </Icon>
                                        </div>
                                    )}

                                    {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                                    {/* {error?.firstName !== "" && <span className="invalid">{error?.firstName}</span>} */}
                                </div>
                            </Col>

                        </Row>

                        <div className="justify-end">
                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                <li>
                                    <Button color="primary" size="md" type="submit">
                                        Save
                                    </Button>
                                </li>
                                <li>
                                    <a
                                        href="#cancel"
                                        onClick={(ev) => {
                                            ev.preventDefault();
                                            onFormCancel();
                                        }}
                                        className="link link-light"
                                    >
                                        Cancel
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};
export default License;
